import * as Yup from 'yup';

export const validationSchema = ({ t }) => {
  return Yup.object().shape({
    carrier: Yup.string()
      .nullable()
      .required(t('Carrier is required')),
    estimated_delivery: Yup.string()
      .nullable()
      .required(t('Estimated Delivery Date is required')),
    rate: Yup.string()
      .nullable()
      .required(t('Rate is required'))
  });
};

export default validationSchema;
